import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const abstractProofApi = generateProofApi('/proof-file/abstract');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('abstract', abstractProofApi);

export function getAbstractProofsByOwnerOptions(abstractId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(abstractId, userId);
}

export function getAbstractProofsOptions(abstractId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(abstractId);
}

export function useUploadOrUpdateAbstractProof(abstractId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(abstractId, queryClient));
}

export function useDeleteAbstractProof(abstractId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(abstractId, queryClient));
}
